export const AUTH_CONFIG = {
    audience: "https://uk.ctmdatahub.com.api/api/v3",
    clientId: "8vj5zkr9GX86jH70Xshb9RixWi4m9rzF",
    domain: "ccsauth.ctmnorth.co.uk",
    scope: "openid email profile access:ctmsmartdata",
    //samlConnection: "portal-qa-idp",
    //samlConnectionNA: "portal-na-stage-idp",
    //samlConnectionProdAu: "portal-prod-idp",
    //samlConnectionProdNA: "portal-na-prod-idp",
    //samlConnectionDevAU: "portal-au-dev-idp",
    //samlConnectionProdAsia: "portal-as-prod-idp",
    //samlConnectionApproval: "ctm-portal-au-qa"



    //Europe
    samlConnectionProdEu: "portal-eu-datahub-prod-idp",
    samlConnectionQaEu: "portal-eu-datahub-qa-idp",

    //Australia
    samlConnectionProdAu: "portal-au-datahub-prod-idp",
    samlConnectionQaAu: "portal-au-datahub-qa-idp",

    //North America
    samlConnectionProdNa: "portal-na-datahub-prod-idp",
    samlConnectionQaNa: "portal-na-datahub-qa-idp",

    //Asia    
    samlConnectionProdAsia: "portal-as-datahub-prod-idp",
    samlConnectionQaAsia: "portal-as-datahub-qa-idp"

};
